import {
    // FILE_UPLOAD,
    CREATE_ARCHITECTURECAREPLAN,
    RETRIEVE_ARCHITECTURECAREPLAN,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ARCHITECTURECAREPLAN,
    UPDATE_ARCHITECTURECAREPLAN,
    DELETE_ARCHITECTURECAREPLAN,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import ARCCarePlan from "../service/arcCarePlan";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await ARCCarePlan.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await ARCCarePlan.create(data);
        dispatch({
            type: CREATE_ARCHITECTURECAREPLAN,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await ARCCarePlan.fetchList(data);
        dispatch({
            type: RETRIEVE_ARCHITECTURECAREPLAN,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await ARCCarePlan.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ARCHITECTURECAREPLAN,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await ARCCarePlan.update(data);
        dispatch({
            type: UPDATE_ARCHITECTURECAREPLAN,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await ARCCarePlan.changeStatus(data);
//         dispatch({
//             type: UPDATE_ARCHITECTURECAREPLAN,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await ARCCarePlan.trash(data);
        dispatch({
            type: DELETE_ARCHITECTURECAREPLAN,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};